import Modal from '@/components/common/modal'

function createComponent (component, componentName, store, data) {
  const on = {
    close: () => {
      store.dispatch('removeGlobalLayer', componentName)
    },
    ...data.on || {}
  }

  const com = {
    name: componentName,
    render (h) {
      return h(component, { props: { data }, on })
    }
  }

  store.dispatch('addGlobalLayer', com)
}

export function createModal (store, data) {
  createComponent(Modal, 'modal', store, data)
}
